import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsuarioAPIService {

  private baseUrl = `${environment.APIEndpoint}usuarios`;
  private baseAuthUrl = `${environment.APIEndpoint}auth`;

  constructor(private http: HttpClient) { }

  /**
   * Abre a sessão persistente do web: a API devolve o access token no corpo e grava o refresh
   * token num cookie HttpOnly (por isso o `withCredentials`).
   */
  login(usuarioLogin: any) {
    return this.http.post(`${this.baseAuthUrl}/login`, { ...usuarioLogin, sessao: 'web' }, { withCredentials: true });
  }

  alterarSenha(data: any) {
    return this.http.post(`${this.baseAuthUrl}/alterar-senha`, data);
  }

  getAll(pageNumber: number = 1, pageSize: number = 100, nome: string = "", login: string = "") {
    return this.http.get(this.baseUrl + `?pageNumber=${pageNumber}&pageSize=${pageSize}&nome=${nome}&login=${login}`);
  }

  getUsers(nome: string = null, login: string = null, setorId: number = null, departamentoId: number = null) {
    var query = "";
    if(nome != "" && nome != null)
      query += `nome=${nome}`;

    if(setorId != null)
      query += `&setorId=${setorId}`;

    if(departamentoId != null)
      query += `&departamentoId=${departamentoId}`;    

    return this.http.get(this.baseUrl + `/listar-usuarios?${query}`);
  }

  getUsersAprovacaoChamados(departamentoId: number) {
    return this.http.get(this.baseUrl + `/listar-usuarios-aprovacao-chamado?departamentoId=${departamentoId}`);
  }

  getCargos(id: number) {
    return this.http.get(this.baseUrl + `/${id}/cargo`);
  }

  createCargo(id: number, data: any) {
    return this.http.post(this.baseUrl + `/${id}/cargo`, data);
  }

  deleteCargo(id: number, cargoId: number) {
    return this.http.delete(this.baseUrl + `/${id}/cargo/${cargoId}`);
  }

  getById(id: number) {
    return this.http.get(`${this.baseUrl}/${id}`);
  }

  create(data: any) {
    return this.http.post(this.baseUrl, data);
  }

  update(id: number, data: any) {
    return this.http.put(`${this.baseUrl}/${id}`, data);
  }

  delete(id: number) {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }
  
  getByToken(token: string) {
    return this.http.get(`${this.baseAuthUrl}/obter-token/${token}`);
  }

  resetarSenha(usuario: any) {
    return this.http.post(`${this.baseAuthUrl}/criar-nova-senha`, usuario);
  }
  
  recuperarSenha(login: string) {
    const recuperarSenha = {
      login: login
    };
    
    return this.http.post(`${this.baseAuthUrl}/recuperar-senha`, recuperarSenha);
  }
}
